module.exports = __webpack_public_path__ + "img/r-101.9b5c7a78.jpg";